/** @file Curve presets of the curve-editor toolbar: id, catalog label and the curve each one writes. */
import type { CurvePreset } from './curveTypes';

/** Toolbar order; ease presets are CSS cubic-bezier values, normalized to each segment's time and change. */
export const CURVE_PRESETS: readonly CurvePreset[] = [
  { id: 'linear', label: 'curves.preset.linear', curve: 'linear' },
  { id: 'stepped', label: 'curves.preset.stepped', curve: 'stepped' },
  { id: 'ease', label: 'curves.preset.ease', curve: { ease: [0.25, 0.1, 0.25, 1] } },
  { id: 'easeIn', label: 'curves.preset.easeIn', curve: { ease: [0.42, 0, 1, 1] } },
  { id: 'easeOut', label: 'curves.preset.easeOut', curve: { ease: [0, 0, 0.58, 1] } },
  { id: 'easeInOut', label: 'curves.preset.easeInOut', curve: { ease: [0.42, 0, 0.58, 1] } },
  { id: 'backIn', label: 'curves.preset.backIn', curve: { ease: [0.36, 0, 0.66, -0.56] } },
  { id: 'backOut', label: 'curves.preset.backOut', curve: { ease: [0.34, 1.56, 0.64, 1] } },
];
